/* eslint-disable jsx-quotes */
import React, { useRef, useState } from 'react';
import MetaSeo from '../MetaSeo';
import { Tabs } from 'antd';
import BreadcrumbComponent from '../Other/BreadCrumbComponent';
import Device from '../Device';
import Slider from 'react-slick';
import { useRouter } from 'next/router';
import TextFooter from '../TextFooter';

const About = props => {
  const { administrator, president, control, staff, all, seo } = props;
  const {title_seo, description, text_footer} = seo || {};
  const router = useRouter();
  const aboutRef = useRef(null);

  const LISTITEM = [
    administrator?.rows?.length > 0 && {
      title: 'Hội đồng Quản trị',
      id: 'administrator',
      data: administrator.rows,
    },
    president?.rows?.length > 0 && {
      title: 'Ban Giám đốc',
      id: 'president',
      data: president.rows,
    },
    control?.rows?.length > 0 && {
      title: 'Ban kiểm soát',
      id: 'controll',
      data: control.rows,
    },
    staff?.rows?.length > 0 && {
      title: 'Nhân sự chủ chốt',
      id: 'staff',
      data: staff.rows,
    },
  ].filter(e => e);

  const [sliderActive, setSliderActive] = useState(0);
  function scrollToItem(_activeIndex) {
    try {
      const container = document.getElementById('c-home-about__professor_list');
      if (container) {
        setSliderActive(_activeIndex);
        const item = document.getElementById(LISTITEM[_activeIndex].id);
        const itemRect = item.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        let offset =
          itemRect.left -
          containerRect.left -
          containerRect.width / 2 +
          itemRect.width / 2;
          if (_activeIndex === 0 || _activeIndex === LISTITEM.length - 1){
            offset =
              itemRect.left -
              containerRect.left -
              containerRect.width / 2 +
              itemRect.width / 2;
          }
        container.scrollBy({ left: offset, behavior: 'smooth' });
      }
    } catch (err) {
      console.log('err===========>', err);
    }
  }

  let settingAdministrator = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow:
      administrator?.rows?.length <= 3 ? administrator?.rows?.length : 3,
    slidesToScroll: 1,
    // nextArrow: <></>,
    // prevArrow: <></>,
    // spaceBetwwen: 64,
    customPaging: () => {
      return <span></span>;
    },
    nextArrow: (
      <div className="controls_s">
        <img src="/assets/img/home/next_s.svg" alt="" />
      </div>
    ),
    prevArrow: (
      <div className="controls_s">
        <img src="/assets/img/home/pre_s.svg" alt="" />
      </div>
    ),
    // dotsClass: 'slick-thumb-dot',
    responsive: [
      {
        breakpoint: 725,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  let settingStaff = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: staff?.rows?.length <= 3 ? staff?.rows?.length : 3,
    slidesToScroll: 1,
    // nextArrow: <></>,
    // prevArrow: <></>,
    // spaceBetwwen: 64,
    customPaging: () => {
      return <span></span>;
    },
    nextArrow: (
      <div className="controls_s">
        <img src="/assets/img/home/next_s.svg" alt="" />
      </div>
    ),
    prevArrow: (
      <div className="controls_s">
        <img src="/assets/img/home/pre_s.svg" alt="" />
      </div>
    ),
    // dotsClass: 'slick-thumb-dot',
    responsive: [
      {
        breakpoint: 725,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  let settingPreisdent = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: president?.rows?.length <= 3 ? president?.rows?.length : 3,
    slidesToScroll: 1,
    // nextArrow: <></>,
    // prevArrow: <></>,
    // spaceBetwwen: 64,
    customPaging: () => {
      return <span></span>;
    },
    nextArrow: (
      <div className="controls_s">
        <img src="/assets/img/home/next_s.svg" alt="" />
      </div>
    ),
    prevArrow: (
      <div className="controls_s">
        <img src="/assets/img/home/pre_s.svg" alt="" />
      </div>
    ),
    // dotsClass: 'slick-thumb-dot',
    responsive: [
      {
        breakpoint: 725,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  let settingControll = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: control?.rows?.length <= 3 ? control?.rows?.length : 3,
    slidesToScroll: 1,
    // nextArrow: <></>,
    // prevArrow: <></>,
    // spaceBetwwen: 64,
    customPaging: () => {
      return <span></span>;
    },
    nextArrow: (
      <div className="controls_s">
        <img src="/assets/img/home/next_s.svg" alt="" />
      </div>
    ),
    prevArrow: (
      <div className="controls_s">
        <img src="/assets/img/home/pre_s.svg" alt="" />
      </div>
    ),
    // dotsClass: 'slick-thumb-dot',
    responsive: [
      {
        breakpoint: 725,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const items = [
    administrator?.rows?.length > 0 && {
      key: '1',
      label: 'Hội đồng Quản trị',
      children: (
        <>
          <div className="p-tabs">
            <Slider {...settingAdministrator}>
              {administrator?.rows?.map(e => {
                return (
                  <div
                    className="p-tabs__container"
                    onClick={() => router.push(`/chuyen-gia/${e.url}`)}
                  >
                    <div className="p-tabs__container-portrait">
                      <a href={`/chuyen-gia/${e.url}`}>
                        <img
                          src={e.image}
                          style={{ width: '372px', height: '486px' }}
                          alt="image_portrait"
                        />
                      </a>
                      <div class="overlay"></div>
                    </div>
                    <div className="p-tabs__container-information">
                      <p className="p-tabs__container-information__m">
                        {e.gender === 2 ? 'Bà' : 'Ông'}
                      </p>
                      <p className="p-tabs__container-information__name">
                        {e.fullname}
                      </p>
                      <p className="p-tabs__container-information__position">
                        {e.position}
                      </p>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </>
      ),
    },
    president?.rows?.length > 0 && {
      key: '2',
      label: 'Ban Giám đốc',
      children: (
        <>
          <div className="p-tabs">
            <Slider {...settingPreisdent}>
              {president?.rows?.map(e => {
                return (
                  <div className="p-tabs__container">
                    <div className="p-tabs__container-portrait">
                      <a href={`/chuyen-gia/${e.url}`}>
                        <img
                          src={e.image}
                          style={{ width: '372px', height: '486px' }}
                          alt="image_portrait"
                        />
                      </a>
                      <div class="overlay"></div>
                    </div>
                    <div className="p-tabs__container-information">
                      <p className="p-tabs__container-information__m">
                        {e.gender === 2 ? 'Bà' : 'Ông'}
                      </p>
                      <p className="p-tabs__container-information__name">
                        {e.fullname}
                      </p>
                      <p className="p-tabs__container-information__position">
                        {e.position}
                      </p>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </>
      ),
    },
    control?.rows?.length > 0 && {
      key: '3',
      label: 'Ban kiểm soát',
      children: (
        <>
          <div className="p-tabs">
            <Slider {...settingControll}>
              {control?.rows?.map(e => {
                return (
                  <div className="p-tabs__container">
                    <div className="p-tabs__container-portrait">
                      <a href={`/chuyen-gia/${e.url}`}>
                        <img
                          src={e.image}
                          style={{ width: '372px', height: '486px' }}
                          alt="image_portrait"
                        />
                      </a>
                      <div class="overlay"></div>
                    </div>
                    <div className="p-tabs__container-information">
                      <p className="p-tabs__container-information__m">
                        {e.gender === 2 ? 'Bà' : 'Ông'}
                      </p>
                      <p className="p-tabs__container-information__name">
                        {e.fullname}
                      </p>
                      <p className="p-tabs__container-information__position">
                        {e.position}
                      </p>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </>
      ),
    },
    staff?.rows?.length > 0 && {
      key: '4',
      label: 'Nhân sự chủ chốt',
      children: (
        <>
          <div className="p-tabs">
            <Slider {...settingStaff}>
              {staff?.rows?.map(e => {
                return (
                  <div className="p-tabs__container">
                    <div className="p-tabs__container-portrait">
                      <a href={`/chuyen-gia/${e.url}`}>
                        <img
                          src={e.image}
                          style={{ width: '372px', height: '486px' }}
                          alt="image_portrait"
                        />
                      </a>
                      <div class="overlay"></div>
                    </div>
                    <div className="p-tabs__container-information">
                      <p className="p-tabs__container-information__m">
                        {e.gender === 2 ? 'Bà' : 'Ông'}
                      </p>
                      <p className="p-tabs__container-information__name">
                        {e.fullname}
                      </p>
                      <p className="p-tabs__container-information__position">
                        {e.position}
                      </p>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </>
      ),
    },
  ];

  const dataSeo = {
    description: description || '',
    title: title_seo || '',
    url: "https://hanagold.vn/gioi-thieu",
  };

  return (
    <>
      <MetaSeo {...dataSeo}/>
      <section id="about" ref={aboutRef} className="">
        <div className="c-home-about">
          <div className="about_breadcrumb_component">
            <BreadcrumbComponent title="Giới thiệu HanaGold" url='gioi-thieu'/>
          </div>
          <h1 className="c-home-about__title">
            Công ty Cổ phần Vàng Bạc Đá Quý HanaGold
          </h1>
          <p className="c-home-about__description">Xin kính chào Quý khách!</p>
        </div>
        <div className="c-home-about-us">
          <h2 className="c-home-about__h2">Về chúng tôi</h2>
          <div className="c-home-about__h2__text">
            <Device>
              {({ isMobile }) => (
                <>
                  {isMobile && (
                    <>
                      <p className="c-home-about__description_h2">
                        Công ty CP Vàng Bạc Đá Quý HanaGold, thành lập năm 2020,
                        là doanh nghiệp khởi nghiệp đổi mới trong lĩnh vực vàng
                        bạc đá quý.
                      </p>
                      <p className="c-home-about__description_h2 pt-16">
                        Chúng tôi ứng dụng công nghệ 4.0 vào kinh doanh vàng,
                        tạo bước đột phá trong ngành. HanaGold phát triển mô
                        hình cải tiến, đảm bảo giá trị tài sản và mang lại sự an
                        tâm cho khách hàng.
                      </p>
                    </>
                  )}
                  {!isMobile && (
                    <>
                      <p className="c-home-about__description_h2">
                        Công ty cổ phần Vàng Bạc Đá Quý HanaGold thành lập vào
                        năm 2020, là doanh nghiệp khởi nghiệp đổi mới sáng tạo
                        trong lĩnh vực vàng bạc đá quý. Chúng tôi ứng dụng công
                        nghệ 4.0 trong hoạt động kinh doanh vàng (tiệm vàng công
                        nghệ 4.0).
                      </p>
                      <p className="c-home-about__description_h2">
                        Tiềm năng trong thời đại công nghệ 4.0 cùng với nhu cầu
                        sử dụng và đầu tư thị trường vàng, HanaGold nhanh chóng
                        chớp lấy thời cơ phát triển ngành vàng tại Việt Nam theo
                        mô hình cải tiến hơn so với truyền thống, tạo bước đột
                        phá cho nền kinh doanh vàng tại Việt Nam.
                      </p>
                      <p className="c-home-about__description_h2">
                        Nhiệm vụ của chúng tôi là đảm bảo giá trị tài sản cho
                        bạn và đem lại sự an tâm khi gắn kết.
                      </p>
                    </>
                  )}
                </>
              )}
            </Device>
          </div>
        </div>
        <Device>
          {({ isMobile }) => (
            <>
              {isMobile && (
                <>
                  <div className="c-home-about__dogma">
                    <div className="c-home-about__item">
                      <div className="c-home-about__item__gold">
                        <h3>Chiến lược</h3>
                        <img
                          src="/assets/img/about/gold.svg"
                          style={{ width: '96px', height: '96px' }}
                        />
                      </div>
                      <div className="c-home-about__item__gold__title">
                        <p className="c-home-about__item__gold__description">
                          Ứng dụng công nghệ 4.0 trong phát triển kinh doanh
                          ngành vàng bạc đá quý tại Việt Nam, biến vàng trở nên
                          linh hoạt hơn.
                        </p>
                      </div>
                    </div>
                    <div className="c-home-about__item">
                      <div className="c-home-about__item__gold">
                        <h3>Tầm nhìn</h3>
                        <img
                          src="/assets/img/about/vision.svg"
                          style={{ width: '96px', height: '96px' }}
                        />
                      </div>
                      <div className="c-home-about__item__gold__title">
                        <p className="c-home-about__item__gold__description">
                          Trở thành chuỗi tiệm vàng quốc dân ứng dụng công nghệ
                          4.0 an toàn, tiện lợi, nhanh chóng.
                        </p>
                      </div>
                    </div>
                    <div className="c-home-about__item">
                      <div className="c-home-about__item__gold">
                        <h3>Sứ mệnh</h3>
                        <img
                          src="/assets/img/about/star.svg"
                          style={{ width: '96px', height: '96px' }}
                        />
                      </div>
                      <div className="c-home-about__item__gold__title">
                        <p className="c-home-about__item__gold__description">
                          Mang lại cơ hội ứng dụng công nghệ 4.0 trong hoạt động
                          kinh doanh vàng tại Việt Nam
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {!isMobile && (
                <>
                  <div className="c-home-about__dogma_container">
                    <div className="c-home-about__dogma_background">
                      <div className="c-home-about__dogma_background_dark"></div>
                      <div className="c-home-about__dogma">
                        <div className="c-home-about__item">
                          <div className="c-home-about__item__gold">
                            <img src="/assets/img/about/gold.svg" />
                          </div>
                          <div className="c-home-about__item__gold__title">
                            <div>
                              <h3>
                                Chiến<span> lược</span>
                              </h3>
                              <p className="c-home-about__item__gold__description">
                                Ứng dụng công nghệ 4.0 trong phát triển kinh
                                doanh ngành vàng bạc đá quý tại Việt Nam, biến
                                vàng trở nên linh hoạt hơn.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="c-home-about__item">
                          <div className="c-home-about__item__vision">
                            <img src="/assets/img/about/vision.svg" />
                          </div>
                          <div className="c-home-about__item__gold__title">
                            <div>
                              <h3>
                                Tầm<span> nhìn</span>
                              </h3>
                              <p className="c-home-about__item__gold__description">
                                Trở thành chuỗi tiệm vàng quốc dân ứng dụng công
                                nghệ 4.0 an toàn, tiện lợi, nhanh chóng.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="c-home-about__item">
                          <div className="c-home-about__item__star">
                            <img src="/assets/img/about/star.svg" />
                          </div>
                          <div className="c-home-about__item__gold__title">
                            <div>
                              <h3>
                                Sứ<span> mệnh</span>
                              </h3>
                              <p className="c-home-about__item__gold__description">
                                Mang lại cơ hội ứng dụng công nghệ 4.0 trong
                                hoạt động kinh doanh vàng tại Việt Nam.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </Device>
        <Device>
          {({ isMobile }) => (
            <>
              {!isMobile && (
                <>
                  {all?.rows?.length > 0 && (
                    <div className="c-home-about__professor">
                      <div className="c-home-about__professor__text">
                        <h2>Đội Ngũ Chuyên Gia HanaGold</h2>
                        <p>
                          Khám phá các chuyên gia hàng đầu trong ngành, những
                          người đồng hành & góp phần trên hành trình phát triển,
                          nâng cấp sản phẩm và dịch vụ của HanaGold, và nhận
                          được những thông tin giá trị từ chuyên môn của họ.
                        </p>
                      </div>
                      <div className="c-home-about__professor__human">
                        <Tabs defaultActiveKey="1" centered items={items} />
                      </div>
                    </div>
                  )}
                </>
              )}
              {isMobile && (
                <>
                  {all?.rows?.length > 0 && (
                    <div className="c-home-about__professor">
                      <div className="c-home-about__professor_text">
                        <h2>Đội Ngũ Chuyên Gia HanaGold</h2>
                        <p>
                          Khám phá các chuyên gia hàng đầu trong ngành, những
                          người đồng hành & góp phần trên hành trình phát triển,
                          nâng cấp sản phẩm và dịch vụ của HanaGold, và nhận
                          được những thông tin giá trị từ chuyên môn của họ.
                        </p>
                      </div>
                      <div className="c-home-about__professor_block-title">
                        <img
                          src="/assets/img/about/professor_back.svg"
                          onClick={() => {
                            if (sliderActive !== 0) {
                              const _activeIndex = sliderActive - 1;
                              scrollToItem(_activeIndex);
                            } else {
                              scrollToItem(LISTITEM?.length - 1);
                            }
                          }}
                        />
                        <h3>{LISTITEM[sliderActive]?.title}</h3>
                        <img
                          src="/assets/img/about/professor_next.svg"
                          onClick={() => {
                            if (sliderActive < LISTITEM?.length - 1) {
                              const _activeIndex = sliderActive + 1;
                              scrollToItem(_activeIndex);
                            } else {
                              scrollToItem(0);
                            }
                          }}
                        />
                      </div>
                      <div
                        id="c-home-about__professor_list"
                        className="c-home-about__professor_list"
                      >
                        {LISTITEM?.map((elm, i) => (
                          <div
                            key={i}
                            id={elm.id}
                            className="about__professor_list-item c-home-about__professor_block"
                          >
                            {elm.data.length > 2 ? (
                              <div className="c-home-about__professor_block-information">
                                {elm?.data?.map(e => (
                                  <div
                                    className="c-home-about__professor_block-item"
                                    onClick={() =>
                                      router.push(`/chuyen-gia/${e.url}`)
                                    }
                                  >
                                    <a href={`/chuyen-gia/${e.url}`}>
                                      <img src={e.image} />
                                    </a>
                                    <div className="c-home-about__professor_block-name overlay_mb">
                                      <p className="c-home-about__professor_block-gender">
                                        {e.gender === 2 ? 'BÀ' : 'ÔNG'}
                                      </p>
                                      <h4 className="c-home-about__professor_block-fullname">
                                        {e.fullname}
                                      </h4>
                                      <p className="c-home-about__professor_block-position">
                                        {e.position}
                                      </p>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="c-home-about__professor_block-information">
                                {elm?.data?.map(e => (
                                  <div
                                    className="c-home-about__professor_block-item"
                                    onClick={() =>
                                      router.push(`/chuyen-gia/${e.url}`)
                                    }
                                  >
                                    <a href={`/chuyen-gia/${e.url}`}>
                                      <img src={e.image} />
                                    </a>
                                    <div className="c-home-about__professor_block-name overlay_mb">
                                      <p className="c-home-about__professor_block-gender">
                                        {e.gender === 2 ? 'BÀ' : 'ÔNG'}
                                      </p>
                                      <h4 className="c-home-about__professor_block-fullname">
                                        {e.fullname}
                                      </h4>
                                      <p className="c-home-about__professor_block-position">
                                        {e.position}
                                      </p>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </Device>
      </section>
      <TextFooter text={text_footer} has_background/>
    </>
  );
};

export default About;
